// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__axxUW","newExpiryDate":"styles_newExpiryDate__2uQ3r","footer":"styles_footer__JPR4d"};